import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import OnDOMReady from "shared/util/OnDOMReady";
import NavBar from "shared/components/NavBar";
import { reducer } from "ducks/navbar";
import addToGlobalStore from "shared/redux/addToGlobalStore";
import { isDesktop } from "shared/util/EnvironmentHelpers";

const NAV_BAR_ROOT_ELEMENT_ID = "navigation";

// eslint-disable-next-line import/no-mutable-exports
let store;

OnDOMReady(() => {
	store = addToGlobalStore({
		navbar: reducer,
	});

	const root = document.getElementById(NAV_BAR_ROOT_ELEMENT_ID);

	if (!root) return;

	if (isDesktop) {
		ReactDOM.render(
			<Provider store={store}>
				<NavBar />
			</Provider>,
			root,
		);
	}
});

export {
	store,
};



// WEBPACK FOOTER //
// ./src/features/navbar/index.js